import React from 'react';
import { Table, Button, Modal, Form, Input, Select, Popconfirm, Breadcrumb, message } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined, HomeOutlined, TeamOutlined } from '@ant-design/icons';
import { getGroups, createGroup, updateGroup, deleteGroup, getCompanies, updateTag, getTags } from '../apis'; // Import necessary API functions
import StoreManager from '../appdata';

const { Option } = Select;

class GroupManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      companies: [],
      isModalVisible: false,
      isAddTagModalVisible: false, // Quản lý trạng thái modal "Add Tag"
      editingGroup: null,
      selectedTagId: null, // Lưu `tag_id` được chọn
      tags: [], // Danh sách thẻ
    };
  }

  componentDidMount() {
    StoreManager.rootState.thisGroupManagement = this;
    this.fetchGroups();
    this.fetchCompanies();
  }

  fetchGroups = async () => {
    try {
      const groups = await getGroups(); // Gọi API mới
      this.setState({ groups: groups.reverse() });
    } catch (error) {
      console.error('Error fetching groups:', error.message);
      message.error(`Error fetching groups: ${error.message}`);
    }
  };

  fetchCompanies = async () => {
    try {
      const companies = await getCompanies(); // Gọi API mới
      this.setState({ companies });
    } catch (error) {
      console.error('Error fetching companies:', error.message);
      message.error(`Error fetching companies: ${error.message}`);
    }
  };

  // Hiển thị modal "Add Tag"
showAddTagModal = async (group) => {
  try {
    const tags = await getTags(); // Lấy danh sách thẻ từ API
    this.setState({ 
      isAddTagModalVisible: true, 
      editingGroup: group, 
      tags 
    });
  } catch (error) {
    console.error('Error fetching tags:', error.message);
    message.error(`Lỗi khi lấy danh sách thẻ: ${error.message}`);
  }
};

// Xử lý xác nhận thêm thẻ vào group
handleAddTagToGroup = async () => {
  const { editingGroup, selectedTagId } = this.state;

  if (!selectedTagId) {
    message.error('Vui lòng chọn một thẻ!');
    return;
  }

  try {
    const updatedTag = { group_id: editingGroup._id }; // Dữ liệu cập nhật
    await updateTag(selectedTagId, updatedTag); // Gọi API cập nhật thẻ
    message.success('Thêm thẻ vào nhóm thành công!');
    this.setState({ isAddTagModalVisible: false, selectedTagId: null });
    this.fetchGroups(); // Làm mới danh sách nhóm
  } catch (error) {
    console.error('Error adding tag to group:', error.message);
    message.error(`Lỗi khi thêm thẻ vào nhóm: ${error.message}`);
  }
};

// Đóng modal "Add Tag"
handleAddTagCancel = () => {
  this.setState({ isAddTagModalVisible: false, selectedTagId: null });
};
  

  showModal = (group) => {
    this.setState({
      isModalVisible: true,
      editingGroup: group,
    }, () => {
      const initialValues = {
        group_name: group ? group.group_name : '',
        company: group ? group.company : null,
      };
      this.formRef.current.setFieldsValue(initialValues);
    });
  };

  handleOk = async () => {
    const form = this.formRef.current;
    try {
      const values = await form.validateFields();
  
      if (this.state.editingGroup) {
        await updateGroup(this.state.editingGroup._id, values); // Gọi API cập nhật
        message.success('Group updated successfully!');
      } else {
        await createGroup(values); // Gọi API tạo mới
        message.success('Group created successfully!');
      }
  
      this.setState({ isModalVisible: false, editingGroup: null });
      this.fetchGroups(); // Làm mới danh sách
    } catch (error) {
      console.error('Error saving group:', error.message);
      message.error(`Error saving group: ${error.message}`);
    }
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      editingGroup: null,
    });
  };

  deleteGroup = async (id) => {
    try {
      await deleteGroup(id); // Gọi API xóa
      message.success('Group deleted successfully!');
      this.fetchGroups(); // Làm mới danh sách
    } catch (error) {
      console.error('Error deleting group:', error.message);
      message.error(`Error deleting group: ${error.message}`);
    }
  };

  formRef = React.createRef();

  getCompanyName = (companyId) => {
    if (!Array.isArray(this.state.companies)) return 'Unknown';
    const company = this.state.companies.find(company => company._id === companyId);
    return company ? company.company_name : 'Unknown';
  };

  render() {
    const columns = [
      { title: 'Tên Nhóm', dataIndex: 'group_name', key: 'group_name' },
      { 
        title: 'Công Ty', 
        dataIndex: 'company_id',
        key: 'company_id',
        render: (text, record) => {
          const companyName = this.getCompanyName(record.company_id);
          return companyName;
        }
      },
      {
        title: 'Hành Động',
        key: 'action',
        render: (text, record) => (
          <span>
            <Button 
              type="primary" 
              ghost 
              icon={<EditOutlined />} 
              onClick={() => this.showModal(record)} 
              style={{ marginRight: 10 }} 
            />
            <Popconfirm
              title="Bạn có chắc chắn muốn xóa nhóm này?"
              onConfirm={() => this.deleteGroup(record._id)}
              okText="Có"
              cancelText="Không"
            >
              <Button danger icon={<DeleteOutlined />} style={{ marginRight: 10 }} />
            </Popconfirm>
            <Button 
              type="primary" 
              icon={<PlusOutlined />} 
              onClick={() => this.showAddTagModal(record)} // Thêm hành động "Add Tag"
            >
              Thêm thẻ
            </Button>
          </span>
        ),
      },
    ];
    
    let scrollY = window.innerHeight - 300

    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 14 }}>
          <Breadcrumb
            items={[
              {
                href: '',
                title: <> <HomeOutlined />
                  <span>Home</span>
                </>,
              },
              {
                title: (
                  <>
                    <TeamOutlined />
                    <span>Groups</span>
                  </>
                ),
              }
            ]}
          />
          <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal(null)}>Add Group</Button>
        </div>
        <Table scroll={{ y: scrollY }} bordered dataSource={this.state.groups} columns={columns} rowKey="_id" />
        <Modal
          title={this.state.editingGroup ? "Edit Group" : "Add Group"}
          visible={this.state.isModalVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <Form
            layout="vertical"
            ref={this.formRef}
            initialValues={{ group_name: '', company_id: null }}
          >
            <Form.Item
              label="Group Name"
              name="group_name"
              rules={[{ required: true, message: 'Please input the group name!' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Company"
              name="company_id"
              rules={[{ required: true, message: 'Please select the company!' }]}
            >
              <Select>
                {(this.state.companies || []).map(company => (
                  <Option key={company._id} value={company._id}>
                    {company.company_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
  title="Thêm Thẻ Vào Nhóm"
  visible={this.state.isAddTagModalVisible}
  onOk={this.handleAddTagToGroup}
  onCancel={this.handleAddTagCancel}
  okText="Thêm"
  cancelText="Hủy"
>
  <Form layout="vertical">
    <Form.Item label="Chọn Thẻ">
      <Select
        placeholder="Chọn thẻ muốn thêm vào nhóm"
        onChange={(value) => this.setState({ selectedTagId: value })}
      >
        {this.state.tags.map(tag => (
          <Option key={tag._id} value={tag._id}>
            {tag.tag_id} - {tag.product_name}
          </Option>
        ))}
      </Select>
    </Form.Item>
  </Form>
</Modal>

      </div>
    );
  }
}

export default GroupManagement;
